// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/ui.css";
import ___CSS_LOADER_ICSS_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_menu.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_2___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header containers */
.styles__container___LYbzW {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["headerHeight"]};
  position: fixed;
  top: 0;
  z-index: 999;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
}
@media print {
.styles__container___LYbzW {
    display: none;
}
  }

.styles__containerRed___pvMBG {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__containerGreen___gfsoz {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.styles__innerContainer___x2C2n {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["contentMaxWidth"]};
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
}

.styles__dropTrigger___M11ty {
  border: 0px;
  width: 30px;
  height: 30px;
  background-color: rgba(0, 0, 0, 0);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 25px;
  box-shadow: none;
  display: block;
  transition: all 0.25s;
  z-index: 1;
}

.styles__dropTrigger___M11ty:hover {
    box-shadow: none;
    cursor: pointer;
  }
.styles__headerOverlay___MlT2X {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  margin: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
/* Container */
.styles__headerMenu___zx1Ci {
  background-color: #24384c !important;
  width: 280px;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  height: 100vh;
  overflow-y: auto;

  transition: transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  z-index: 2;
  flex-flow: column nowrap;
  display: flex;
  padding: 0;
}

.styles__menuContent___dLCTQ {
  flex: 1;
  overflow-y: auto;
}

.styles__overlay___IxCRe {
  z-index: 9;
  margin: 30px;
  background: #009938;
}
.styles__headerActive___Yp1w6 {
  transform: translateX(0) !important;
  /* transition: transform 0.3s ease-in-out; */
}
.styles__headerInActive___STlm9 {
  transform: translateX(-100%) !important;
}
.styles__logo___ISFKD {
  align-items: center;
  box-shadow: none;
  display: flex;
  height: 100%;
  justify-content: space-around;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  width: 52px;
}
.styles__logo___ISFKD:hover {
    box-shadow: none;
  }
.styles__logo___ISFKD img {
    vertical-align: top;
    width: 26px;
  }

.styles__xeroRefresh___kD_Lg {
  height: 26px;
  margin-right: 15px;
  padding: 0 15px;
  background: rgba(0, 0, 0, 0.15);
  border: rgba(241, 245, 250, 0.7) 1px solid;
  line-height: 26px;
  text-align: center;
  color: rgba(241, 245, 250, 0.7);
  cursor: default;
}

.styles__xeroRefresh___kD_Lg:hover {
    background: rgba(0, 0, 0, 0.25);
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  }

.styles__xeroRefresh___kD_Lg:active,
  .styles__xeroRefresh___kD_Lg:focus {
    background: rgba(0, 0, 0, 0.25);
    border: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]} 1px solid;
  }

.styles__xeroRefresh___kD_Lg.styles__yellow___NrS5w {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  color: rgba(241, 245, 250, 1);
}

.styles__xeroRefresh___kD_Lg.styles__red___x0ufp {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: rgba(241, 245, 250, 1);
}
`, "",{"version":3,"sources":["webpack://./universal/components/Header/styles.css"],"names":[],"mappings":"AAKA,sBAAsB;AACtB;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oDAAoB;EACpB,eAAe;EACf,MAAM;EACN,YAAY;EACZ,8DAA4B;AAK9B;AAHE;AAZF;IAaI,aAAa;AAEjB;EADE;;AAGF;EAEE,8DAAuB;AACzB;;AAEA;EAEE,8DAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,uDAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,yDAAiD;EACjD,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,UAAU;AAMZ;;AAJE;IACE,gBAAgB;IAChB,eAAe;EACjB;AAEF;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;AACZ;AACA,cAAc;AACd;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;;EAEhB,kEAAkE;EAClE,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;AACA;EACE,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AAUb;AARE;IACE,gBAAgB;EAClB;AAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;AAGF;EAEE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AAajB;;AAXE;IACE,+BAA+B;IAC/B,0DAAyB;IACzB,mDAAkB;EACpB;;AAEA;;IAEE,+BAA+B;IAC/B,8DAA6B;EAC/B;;AAGF;EACE,wDAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,wDAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":["@value colors: \"styles/colors.css\";\n@value helpers: \"styles/helpers.css\";\n@value gtBlueDark, gtGreen, gtGrayDark, gtBlue, gtYellow, gtYellowDark, gtGray, gtBlueLight, gtRed, gtGreen, text from colors;\n@value contentMaxWidth, headerHeight from \"styles/ui.css\";\n\n/* header containers */\n.container {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: headerHeight;\n  position: fixed;\n  top: 0;\n  z-index: 999;\n  background-color: gtBlueDark;\n\n  @media print {\n    display: none;\n  }\n}\n\n.containerRed {\n  composes: container;\n  background-color: gtRed;\n}\n\n.containerGreen {\n  composes: container;\n  background-color: gtGreen;\n}\n\n.innerContainer {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: contentMaxWidth;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n}\n\n.dropTrigger {\n  border: 0px;\n  width: 30px;\n  height: 30px;\n  background-color: rgba(0, 0, 0, 0);\n  background-image: url('styles/img/icon_menu.png');\n  background-position: left center;\n  background-repeat: no-repeat;\n  background-size: 25px;\n  box-shadow: none;\n  display: block;\n  transition: all 0.25s;\n  z-index: 1;\n\n  &:hover {\n    box-shadow: none;\n    cursor: pointer;\n  }\n}\n.headerOverlay {\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  margin: auto;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n/* Container */\n.headerMenu {\n  background-color: #24384c !important;\n  width: 280px;\n  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  height: 100vh;\n  overflow-y: auto;\n\n  transition: transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  z-index: 2;\n  flex-flow: column nowrap;\n  display: flex;\n  padding: 0;\n}\n\n.menuContent {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.overlay {\n  z-index: 9;\n  margin: 30px;\n  background: #009938;\n}\n.headerActive {\n  transform: translateX(0) !important;\n  /* transition: transform 0.3s ease-in-out; */\n}\n.headerInActive {\n  transform: translateX(-100%) !important;\n}\n.logo {\n  align-items: center;\n  box-shadow: none;\n  display: flex;\n  height: 100%;\n  justify-content: space-around;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  width: 52px;\n\n  &:hover {\n    box-shadow: none;\n  }\n\n  img {\n    vertical-align: top;\n    width: 26px;\n  }\n}\n\n.xeroRefresh {\n  composes: button from helpers;\n  height: 26px;\n  margin-right: 15px;\n  padding: 0 15px;\n  background: rgba(0, 0, 0, 0.15);\n  border: rgba(241, 245, 250, 0.7) 1px solid;\n  line-height: 26px;\n  text-align: center;\n  color: rgba(241, 245, 250, 0.7);\n  cursor: default;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.25);\n    border-color: gtBlueLight;\n    color: gtBlueLight;\n  }\n\n  &:active,\n  &:focus {\n    background: rgba(0, 0, 0, 0.25);\n    border: gtBlueLight 1px solid;\n  }\n}\n\n.xeroRefresh.yellow {\n  background: gtYellowDark;\n  color: rgba(241, 245, 250, 1);\n}\n\n.xeroRefresh.red {\n  background: gtRed;\n  color: rgba(241, 245, 250, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"helpers": `"styles/helpers.css"`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"contentMaxWidth": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["contentMaxWidth"]}`,
	"headerHeight": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["headerHeight"]}`,
	"container": `styles__container___LYbzW`,
	"containerRed": `styles__containerRed___pvMBG styles__container___LYbzW`,
	"containerGreen": `styles__containerGreen___gfsoz styles__container___LYbzW`,
	"innerContainer": `styles__innerContainer___x2C2n`,
	"dropTrigger": `styles__dropTrigger___M11ty`,
	"headerOverlay": `styles__headerOverlay___MlT2X`,
	"headerMenu": `styles__headerMenu___zx1Ci`,
	"menuContent": `styles__menuContent___dLCTQ`,
	"overlay": `styles__overlay___IxCRe`,
	"headerActive": `styles__headerActive___Yp1w6`,
	"headerInActive": `styles__headerInActive___STlm9`,
	"logo": `styles__logo___ISFKD`,
	"xeroRefresh": `styles__xeroRefresh___kD_Lg ${___CSS_LOADER_ICSS_IMPORT_2___.locals["button"]}`,
	"yellow": `styles__yellow___NrS5w`,
	"red": `styles__red___x0ufp`
};
export default ___CSS_LOADER_EXPORT___;
